import { cn } from "@/lib/utils";
import type { DealHealthLevel } from "./DealHealthCard";

const DOT: Record<DealHealthLevel, string> = { GOOD: "bg-success", WATCH: "bg-warning", AT_RISK: "bg-danger", UNKNOWN: "bg-muted-foreground/40" };
const WORD: Record<DealHealthLevel, string> = { GOOD: "Good", WATCH: "Watch", AT_RISK: "At risk", UNKNOWN: "Not sure" };

/** A small dot with the AI's health check of a deal on list rows and board cards (nothing when never checked) */
export function HealthDot({ health, className }: { health?: { health: DealHealthLevel; summary: string | null } | null; className?: string }) {
  if (!health) return null;
  const label = `AI health: ${WORD[health.health]}${health.summary ? ` — ${health.summary}` : ""}`;
  return <span role="img" aria-label={label} title={label} className={cn("size-2 shrink-0 rounded-full", DOT[health.health], className)} />;
}
